import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ProjectCard } from './ProjectCard';
import type { ProjectListItem } from '../lib/supabase';
import { getImageUrl } from '../lib/supabase';
interface MasonryGridProps {
  projects: ProjectListItem[];
  onProjectClick: (project: ProjectListItem) => void;
  selectedCategory?: string;
}
export function MasonryGrid({
  projects,
  onProjectClick,
  selectedCategory
}: MasonryGridProps) {
  const [columns, setColumns] = useState(3);
  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth < 768) {
        setColumns(1);
      } else if (window.innerWidth < 1024) {
        setColumns(2);
      } else {
        setColumns(3);
      }
    };
    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);
  const filteredProjects = selectedCategory && selectedCategory !== 'All' ? projects.filter(p => {
    const categories = Array.isArray(p.category) ? p.category : [p.category];
    return categories.includes(selectedCategory);
  }) : projects;
  // Distribute projects across columns
  const columnProjects: ProjectListItem[][] = Array.from({
    length: columns
  }, () => []);
  filteredProjects.forEach((project, index) => {
    columnProjects[index % columns].push(project);
  });
  console.log('MasonryGrid rendering:', filteredProjects.length, 'projects');
  return <div className="grid gap-6" style={{
    gridTemplateColumns: `repeat(${columns}, 1fr)`
  }} data-id="element-151">
      {columnProjects.map((columnItems, columnIndex) => <div key={columnIndex} className="flex flex-col gap-6" data-id="element-152">
          <AnimatePresence mode="popLayout" data-id="element-153">
            {columnItems.map((project, index) => {
          console.log('Rendering project:', project.title, 'thumb_path:', project.thumb_path, 'image_path:', project.image_path);
          return <motion.div key={project.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} onClick={() => onProjectClick(project)} data-id="element-154">
                  <ProjectCard title={project.title} category={project.category} year={project.year} thumb_path={project.thumb_path || project.image_path} media_type={project.media_type} index={columnIndex * columnItems.length + index} data-id="element-155" />
                </motion.div>;
        })}
          </AnimatePresence>
        </div>)}
    </div>;
}